export const TOOGLE_SIDENAV = 'TOOGLE_SIDENAV';